import React from 'react';
import reactDom from '../../../common/react/dom/index';
import VideoPlayerContainer from '../../../components/frontend/BP/VideoPlayerContainer/VideoPlayerContainer';
import TopWidget from '../../../components/frontend/BP/TopWidget/TopWidget';

export default function init() {
	reactDom(<VideoPlayerContainer />, 'js-react-BPvideoPlayer');
	reactDom(<TopWidget />, 'js-react-widget');
}
